function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-318.443 631.578H482.344C502.731 631.578 521.955 639.587 536.474 654.126C537.994 655.648 539.427 657.234 540.802 658.858C566.626 600.72 580.999 536.358 580.999 468.625C580.999 209.81 371.475 0 113.011 0C-145.452 0 -354.977 209.81 -354.977 468.625C-354.977 526.063 -344.637 581.078 -325.753 631.932C-323.337 631.701 -320.897 631.578 -318.443 631.578Z",
  fill: "#BDBDBD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M154.261 80.7328C154.261 59.7365 143.104 41.3607 126.408 31.1963C123.749 29.5781 120.335 31.51 120.335 34.6259V78.8526C120.335 80.1896 119.667 81.4387 118.555 82.1808L98.5977 95.4783C97.2587 96.3715 95.5147 96.3715 94.1757 95.4783L74.2183 82.1808C73.1066 81.4406 72.4381 80.1915 72.4381 78.8526V34.6259C72.4381 31.51 69.0246 29.5781 66.3657 31.1963C49.6728 41.3607 38.5156 59.7365 38.5156 80.7328C38.5156 102.993 51.0577 122.308 69.4449 132.016C71.3015 132.995 72.4419 134.944 72.4419 137.046V304.548C72.4419 317.792 83.1636 328.528 96.3895 328.528C109.615 328.528 120.337 317.792 120.337 304.548V137.046C120.337 134.944 121.477 132.995 123.334 132.016C141.721 122.308 154.261 102.993 154.261 80.7328Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M92.3156 295.465V257.232H75.4852C74.4576 257.232 73.4452 257.294 72.4404 257.387V304.556C72.4404 317.8 83.1621 328.536 96.3881 328.536C104.015 328.536 110.794 324.953 115.18 319.391C102.462 318.819 92.3156 308.343 92.3156 295.465Z",
  fill: "#828282"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M69.4446 132.027C71.3013 133.006 72.4417 134.955 72.4417 137.058V199.93C73.454 199.895 74.4645 199.851 75.4864 199.851H92.3168V127.966C92.3168 125.864 91.1764 123.915 89.3198 122.936C70.9326 113.23 58.3905 93.9134 58.3905 71.6528C58.3905 57.2421 63.6492 44.0651 72.3442 33.9313C71.8686 31.2515 68.8162 29.7175 66.3693 31.2075C49.6726 41.3719 38.5154 59.7478 38.5154 80.7441C38.5154 103.005 51.0575 122.32 69.4446 132.027Z",
  fill: "#828282"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7497 352.853V289.997C42.7497 271.924 57.435 257.219 75.4821 257.219H107.892C123.715 257.219 136.544 244.373 136.544 228.527C136.544 212.682 123.715 199.836 107.892 199.836H75.4821C25.8353 199.836 -14.5549 240.283 -14.5549 289.997V367.604C3.70615 360.708 22.886 355.712 42.7497 352.853Z",
  fill: "#F2F2F2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.30697 358.922V289.997C5.30697 240.283 45.6972 199.836 95.3441 199.836H75.4861C25.8392 199.836 -14.551 240.283 -14.551 289.997V365.49C-8.04504 363.057 -1.42251 360.863 5.30697 358.922Z",
  fill: "#828282"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M332.219 18.498C240.022 18.498 164.586 94.0347 164.586 186.36V326.452L168.469 328.364H495.423L499.853 326.452V186.36C499.853 94.0347 424.417 18.498 332.219 18.498Z",
  fill: "#ECECEB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M245.733 326.452V186.36C245.733 108.034 300.031 41.8011 372.793 23.5133C359.789 20.2444 346.198 18.498 332.219 18.498C240.022 18.498 164.586 94.0347 164.586 186.36V326.452H245.733Z",
  fill: "#828282"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M351.663 574.444L351.951 576.008H374.644C396.647 576.008 414.547 593.933 414.547 615.966V631.581H482.344C488.311 631.581 494.172 632.287 499.851 633.622V326.447H164.586V362.749C259.184 392.636 332.848 472.601 351.663 574.444Z",
  fill: "#4F4F4F"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M321.617 487.119H324.06V326.447H276.306V428.196C293.91 445.656 309.189 465.461 321.617 487.119Z",
  fill: "#BDBDBD"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M353.897 576.017C330.914 446.487 217.903 348.131 81.95 348.131C-54.0034 348.131 -167.016 446.487 -189.999 576.017H353.897Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M-89.0629 574.102C-68.3263 461.848 20.1005 373.375 132.244 352.718C115.935 349.713 99.1313 348.131 81.9552 348.131C-53.3277 348.131 -165.88 445.523 -189.633 574.104H-89.0629V574.102Z",
  fill: "#E0E0E0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M416.458 631.587V615.972C416.458 592.848 397.739 574.102 374.645 574.102H-210.739C-233.833 574.102 -252.552 592.847 -252.552 615.972V631.587H416.458Z",
  fill: "#BDBDBD"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M482.344 787.004H-318.441C-361.649 787.004 -397 751.604 -397 708.338C-397 665.071 -361.649 629.672 -318.441 629.672H482.346C525.553 629.672 560.905 665.071 560.905 708.338C560.903 751.604 525.551 787.004 482.344 787.004Z",
  fill: "#E0E0E0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M474.413 474.051H418.338C418.128 474.051 417.924 474.023 417.723 473.99V487.129H256.031C240.207 487.129 227.378 499.975 227.378 515.82C227.378 531.666 240.207 544.512 256.031 544.512H420.699C450.656 544.512 475.028 520.107 475.028 490.109V473.99C474.827 474.023 474.623 474.051 474.413 474.051Z",
  fill: "#F2F2F2"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M440.043 524.741H275.375C259.551 524.741 246.722 511.895 246.722 496.05C246.722 493.372 247.116 490.792 247.802 488.332C235.991 491.874 227.378 502.829 227.378 515.809C227.378 531.654 240.207 544.5 256.031 544.5H420.699C440.87 544.5 458.496 533.427 467.867 517.043C459.722 521.926 450.205 524.741 440.043 524.741Z",
  fill: "#828282"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M267.46 277.396C266.943 277.396 266.423 277.329 265.913 277.191L232.843 268.318C218.029 264.343 204.727 255.682 195.801 243.196C184.191 226.953 180.619 207.035 185.694 188.067C186.411 185.393 188.825 183.631 191.463 183.631C191.975 183.631 192.494 183.698 193.012 183.837L226.083 192.711C240.898 196.685 254.202 205.348 263.128 217.837C274.738 234.078 278.308 253.995 273.233 272.964C272.822 274.498 271.821 275.805 270.45 276.596C269.533 277.124 268.501 277.396 267.46 277.396Z",
  fill: "#828282"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M252.189 268.322C237.376 264.347 224.073 255.686 215.147 243.198C203.537 226.957 199.965 207.037 205.041 188.068C205.127 187.749 205.239 187.445 205.371 187.152L193.016 183.837C192.499 183.698 191.979 183.631 191.467 183.631C188.829 183.631 186.415 185.394 185.698 188.067C180.623 207.035 184.195 226.953 195.805 243.196C204.731 255.682 218.035 264.345 232.849 268.32L265.919 277.193C266.427 277.329 266.947 277.398 267.466 277.398C268.506 277.398 269.537 277.126 270.454 276.596C271.543 275.967 272.383 275.007 272.895 273.875L252.189 268.322Z",
  fill: "#333333"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M323.541 277.394C324.058 277.394 324.578 277.327 325.088 277.189L357.882 268.391C374.651 263.892 389.401 253.383 398.299 238.458C407.414 223.168 409.901 205.228 405.307 188.067C404.591 185.393 402.176 183.631 399.538 183.631C399.026 183.631 398.507 183.698 397.989 183.837L365.197 192.636C348.426 197.135 333.674 207.644 324.777 222.573C315.663 237.863 313.178 255.803 317.77 272.962C318.181 274.496 319.182 275.803 320.553 276.595C321.47 277.123 322.502 277.394 323.541 277.394Z",
  fill: "#828282"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M338.401 272.96C333.809 255.799 336.296 237.859 345.41 222.571C354.307 207.642 369.059 197.133 385.831 192.634L405.095 187.466C404.199 185.138 401.973 183.631 399.544 183.631C399.032 183.631 398.512 183.698 397.994 183.837L365.203 192.636C348.432 197.135 333.68 207.644 324.782 222.573C315.669 237.863 313.182 255.803 317.774 272.962C318.184 274.496 319.185 275.801 320.557 276.595C321.474 277.124 322.505 277.396 323.544 277.396C324.062 277.396 324.581 277.329 325.09 277.191L338.627 273.559C338.549 273.358 338.457 273.167 338.401 272.96Z",
  fill: "#333333"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M246.82 149.259C259.667 149.259 270.082 138.83 270.082 125.965C270.082 113.101 259.667 102.672 246.82 102.672C233.973 102.672 223.558 113.101 223.558 125.965C223.558 138.83 233.973 149.259 246.82 149.259Z",
  fill: "#828282"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M356.929 149.259C369.776 149.259 380.19 138.83 380.19 125.965C380.19 113.101 369.776 102.672 356.929 102.672C344.081 102.672 333.667 113.101 333.667 125.965C333.667 138.83 344.081 149.259 356.929 149.259Z",
  fill: "#828282"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M302.215 202.679C315.062 202.679 325.476 192.25 325.476 179.385C325.476 166.521 315.062 156.092 302.215 156.092C289.367 156.092 278.953 166.521 278.953 179.385C278.953 192.25 289.367 202.679 302.215 202.679Z",
  fill: "#828282"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M480.141 470.221V380.279C480.141 361.326 464.651 345.23 445.728 345.586C427.375 345.93 412.604 360.934 412.604 379.394V470.221C412.604 473.39 415.169 475.959 418.334 475.959H474.41C477.576 475.959 480.141 473.39 480.141 470.221Z",
  fill: "#828282"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M440.878 470.219V379.392C440.878 365.85 448.845 354.191 460.327 348.794C455.884 346.676 450.948 345.486 445.731 345.586C427.381 345.93 412.607 360.934 412.607 379.394V470.221C412.607 473.39 415.173 475.959 418.338 475.959H446.608C443.443 475.957 440.878 473.388 440.878 470.219Z",
  fill: "#BDBDBD"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M211.629 723.012H-47.7296C-61.7234 723.012 -73.1729 711.547 -73.1729 697.535C-73.1729 683.522 -61.7234 672.057 -47.7296 672.057H211.629C225.623 672.057 237.073 683.522 237.073 697.535C237.073 711.547 225.623 723.012 211.629 723.012Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M46.1546 697.535C46.1546 683.522 57.604 672.057 71.5978 672.057H-47.7296C-61.7234 672.057 -73.1729 683.522 -73.1729 697.535C-73.1729 711.547 -61.7234 723.012 -47.7296 723.012H71.5978C57.604 723.012 46.1546 711.547 46.1546 697.535Z",
  fill: "#828282"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M556.339 494.415C548.864 497.556 544.949 501.477 541.812 508.961C540.519 512.049 536.099 512.049 534.804 508.961C531.667 501.477 527.752 497.556 520.277 494.415C517.194 493.12 517.194 488.694 520.277 487.397C527.752 484.256 531.667 480.335 534.804 472.851C536.097 469.763 540.517 469.763 541.812 472.851C544.949 480.335 548.864 484.256 556.339 487.397C559.424 488.694 559.424 493.118 556.339 494.415Z",
  fill: "white"
});

var SvgIcAlian = function SvgIcAlian(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 782,
    viewBox: "0 0 581 782",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAlian, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_alian.ace4e1e7.svg";
export { ForwardRef as ReactComponent };